import { Collapse, Icon } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';
import { useDownloads } from '../Downloads/containers/DownloadsDataStore';
import TitleScroller from '../Home/TitleScroller';
import { useReviews } from '../Reviews/containers/ReviewsDataStore';
import ViewInListLink from '../UI/ViewInListLink';
import { useRequests } from './containers/RequestsDataStore';
import RequestType from './RequestType';
import { useHistory } from 'react-router-dom';
import {
	getApprovedDownloadableSku,
	getDownloadedReviewedSku,
	getDownloadedNotReviewedSku,
	getDeclinedSku,
	getPendingSku,
} from './RequestFilters';
import LocalStorageKeys from '../Preferences/LocalStorageKeys';
import { useYourBooksDrawer } from '../YourBooks/YourBooksDrawerContext';

const Panel = Collapse.Panel;

RequestsCollapse.propTypes = {
	isMobile: PropTypes.func,
};

function RequestsCollapse({ isMobile }) {
	const history = useHistory();
	const yourBooksDrawer = useYourBooksDrawer();

	const localStorageKey = LocalStorageKeys.expandedRequestsPanels;
	const localStorageValue = localStorage.getItem(localStorageKey);

	const getRequestKeys = () => {
		return Object.keys(RequestType).map(request => {
			return RequestType[request].key;
		});
	};

	const [collapsedPanels, setCollapsedPanels] = React.useState(
		localStorageValue ? JSON.parse(localStorageValue) : getRequestKeys(),
	);
	const isMobileSize = isMobile();

	React.useEffect(() => {
		localStorage.setItem(localStorageKey, JSON.stringify(collapsedPanels));
	}, [collapsedPanels]);

	const requestsDataStore = useRequests();
	const { isLoading, requests, conversations } = requestsDataStore.state;

	const renderPanel = (skus = [], requestType) => {
		const filteredRequests = requests.filter(request =>
			skus.includes(request.sku),
		);
		return (
			((skus && skus.length > 0) || requestType.doShowIfZero) && (
				<Panel
					style={{ marginLeft: '-10px' }}
					header={requestType.text}
					extra={skus.length}
					key={requestType.key}>
					<TitleScroller
						titles={
							!isLoading && filteredRequests && filteredRequests
						}
						conversations={conversations && conversations}
						communityId={0}
					/>
					<div onClick={() => handleClick(requestType.key)}>
						<ViewInListLink />
					</div>
				</Panel>
			)
		);
	};

	const handleClick = selectedKey => {
		requestsDataStore.setSelectedMenuOption(selectedKey);
		history.push('/requests');
		yourBooksDrawer && yourBooksDrawer.close();
	};

	const reviewsDataStore = useReviews();
	const { reviews } = reviewsDataStore.state;

	const downloadsDataStore = useDownloads();
	const { downloads } = downloadsDataStore.state;

	const requestSkus = requests.map(item => item.sku);

	const downloadSkus = downloads
		.map(item => item.sku)
		.filter(sku => requestSkus.includes(sku));

	const reviewedSkus = reviews && reviews.map(item => item.sku);

	const logChange = e => {
		setCollapsedPanels(e);
	};

	return (
		<>
			{requests && requests.length > 0 ? (
				<Collapse
					className={
						!isMobileSize
							? 'standard-collapse'
							: 'standard-collapse-mobile'
					}
					bordered={false}
					onChange={logChange}
					defaultActiveKey={collapsedPanels}
					activeKeys={collapsedPanels}
					expandIcon={({ isActive }) => (
						<Icon type="caret-right" rotate={isActive ? 90 : 0} />
					)}>
					{renderPanel(
						getApprovedDownloadableSku(requests, downloadSkus),
						RequestType.ReadyToDownload,
					)}
					{renderPanel(
						getDownloadedNotReviewedSku(downloadSkus, reviewedSkus),
						RequestType.DownloadedNotReviewed,
					)}
					{renderPanel(
						getDownloadedReviewedSku(downloadSkus, reviewedSkus),
						RequestType.DownloadedReviewed,
					)}
					{renderPanel(
						getDeclinedSku(requests),
						RequestType.Declined,
					)}
					{renderPanel(getPendingSku(requests), RequestType.Pending)}
				</Collapse>
			) : (
				<div className="no-content-text">
					Review copy requests you make will show up here
				</div>
			)}
		</>
	);
}

export default withIsMobile(RequestsCollapse);
